export const BASIC_FEATURES = [
  <>
    Alta en plataforma <b>Feek</b>
  </>,
  '1 campaña sin límite de reservas',
  '1 story en redes sociales',
];

export const GROWTH_FEATURES = [
  <>
    Alta en plataforma <b>Feek</b>
  </>,
  '3 campañas activas',
  '20 reservas garantizadas',
  'Reporte mensual de resultados',
  '1 creador de contenido incluido',
  '1 story mensual en redes',
];

export const PLANS = [
  {
    name: 'Feek Básico',
    duration: '1 mes',
    price: '$999',
    infoText:
      'Ideal para negocios que buscan aumentar su visibilidad rápidamente.',
    features: BASIC_FEATURES,
    popular: false,
  },
  {
    name: 'Feek Growth',
    duration: '3 meses',
    price: '$3,500',
    infoText:
      'Ideal para negocios que quieren crecer de forma acelerada, con campañas, contenido y métricas.',
    features: GROWTH_FEATURES,
    popular: true,
  },
];

export const ADDONS = [
  {
    category: 'Creador de contenido',
    name: 'Reel de Instagram',
    description:
      'Visita al negocio + producción de 1 Reel listo para publicar',
    duration: 'Hasta 2 horas',
  },
  {
    category: 'Creador de contenido',
    name: 'Stories de Instagram',
    description: 'Visita al negocio + 5 stories creadas y publicadas',
    duration: 'Hasta 2 horas',
  },
  {
    category: 'Creador de contenido',
    name: 'Tik Tok',
    description:
      'Visita al negocio + producción de 1 Tik Tok orgánico',
    duration: 'Hasta 2 horas',
  },
  {
    category: 'Notificaciones push',
    name: 'Push Notifications',
    description:
      '10 notificaciones push enviadas a usuarios activos en la app',
    days: '30 días',
  },
  {
    category: 'Mensajería directa',
    name: 'Mensajes de Whatsapp',
    description: '5 alertas y promociones enviadas vía Whatsapp',
    days: '30 días',
  },
];
